import { ISelectItem } from '@lla-platform/core/core-ui'

export enum EmployeeEfficiencyType {
  EffectiveLaborRate = 'EffectiveLaborRate',
  LaborEfficiency = 'LaborEfficiency',
  InvoicedLabor = 'InvoicedLabor'
}

export const EmployeeEfficiencyTypeToLabel: { [key: string]: string } = {
  EffectiveLaborRate: 'Effective Labor Rate',
  LaborEfficiency: 'Labor Efficiency',
  InvoicedLabor: 'Invoiced Labor'
}

export const EmployeeEfficiencyTypeItems: ISelectItem[] = [
  {
    label: EmployeeEfficiencyTypeToLabel[EmployeeEfficiencyType.EffectiveLaborRate],
    value: EmployeeEfficiencyType.EffectiveLaborRate
  },
  {
    label: EmployeeEfficiencyTypeToLabel[EmployeeEfficiencyType.LaborEfficiency],
    value: EmployeeEfficiencyType.LaborEfficiency
  },
  {
    label: EmployeeEfficiencyTypeToLabel[EmployeeEfficiencyType.InvoicedLabor],
    value: EmployeeEfficiencyType.InvoicedLabor
  }
]
